import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import BaseLink from '~/components/base/BaseLink';
import Icon from '~/components/base/Icon';
import Modal from '~/components/base/Modal';

import ComparisonTable from '~/components/ComparisonTable';

import { h3, p } from '~/styles/typography';
import { transition } from '~/styles/transition';
import { AcfLink } from '~/utilities/propTypes';

import { dynamicFontSize, formatText } from '~/utilities/helpers';

const ArrowCtaTitle = styled.h3`
    ${transition({}, 'color')};
    ${h3};
    margin-bottom: 10px;
    font-size: ${dynamicFontSize(2.2, 3.4, 3.8)};
`;

export const CtaLink = styled(BaseLink)`
    width: 100%;
    display: flex;
    justify-content: space-between;

    &:hover,
    &:focus {
        ${ArrowCtaTitle} {
            color: ${({ theme }) => theme.colors.primary.yellow};
        }

        svg * {
            color: ${({ theme }) => theme.colors.accent.yellow};
        }
    }

    @media (min-width: ${({ theme }) => theme.breakpoint.tablet}) {
        display: block;
    }
`;

export const CtaButton = styled.button`
    width: 100%;
    display: flex;
    justify-content: space-between;
    text-align: left;
    color: ${({ theme }) => theme.colors.primary.white};

    &:hover,
    &:focus {
        ${ArrowCtaTitle} {
            color: ${({ theme }) => theme.colors.primary.yellow};
        }

        svg * {
            color: ${({ theme }) => theme.colors.accent.yellow};
        }
    }

    @media (min-width: ${({ theme }) => theme.breakpoint.tablet}) {
        display: block;
    }
`;

const ArrowCtaCopy = styled.p`
    ${p};
    color: ${({ theme }) => theme.colors.primary.white};
    margin-bottom: ${({ theme }) => theme.layout.gutter};
    display: none;

    @media (min-width: ${({ theme }) => theme.breakpoint.tablet}) {
        display: block;
    }
`;

const ArrowCta = ({
    link: { url, title },
    copy,
    useComparisonTable,
    comparisonTableProductCategory
}) => {
    const [open, setOpen] = useState(false);
    return useComparisonTable ? (
        <>
            <CtaButton onClick={() => setOpen(true)}>
                <ArrowCtaTitle>{formatText(title)}</ArrowCtaTitle>
                {copy ? <ArrowCtaCopy>{formatText(copy)}</ArrowCtaCopy> : null}
                <Icon
                    icon="circle-arrow"
                    color="yellow"
                    sizeLarge={50}
                    size={50}
                    sizeTablet={40}
                    sizeMobile={40}
                />
            </CtaButton>
            <Modal {...{ open, setOpen }}>
                <ComparisonTable
                    productCategory={comparisonTableProductCategory}
                />
            </Modal>
        </>
    ) : (
        <CtaLink to={url}>
            <ArrowCtaTitle>{formatText(title)}</ArrowCtaTitle>
            {copy ? <ArrowCtaCopy>{formatText(copy)}</ArrowCtaCopy> : null}
            <Icon
                icon="circle-arrow"
                color="yellow"
                sizeLarge={50}
                size={50}
                sizeTablet={40}
                sizeMobile={40}
            />
        </CtaLink>
    );
};

ArrowCta.propTypes = {
    copy: PropTypes.string,
    link: AcfLink
};

export default ArrowCta;
